var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.538 8.532l-6.769 4.331A.5.5 0 019 12.441V3.779a.498.498 0 01.769-.421l6.769 4.331a.5.5 0 010 .843M20.062 0H3.937A3.944 3.944 0 000 3.94v9.121A3.943 3.943 0 003.937 17h16.125A3.943 3.943 0 0024 13.061V3.94A3.944 3.944 0 0020.062 0"}));
}

Youtube.defaultProps = {"width":"24","height":"17"};

module.exports = Youtube;

Youtube.default = Youtube;
